import { render, staticRenderFns } from "./SSH.vue?vue&type=template&id=95dbc650&scoped=true"
import script from "./SSH.vue?vue&type=script&lang=js"
export * from "./SSH.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95dbc650",
  null
  
)

export default component.exports